import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map, Observable } from 'rxjs';
import { StaffedRole } from '../models/staffedRole';
import { StaffedRoleRolloverPreview, StaffedRoleRolloverSummary } from '../models/staffedRoleRollover';
import { getCurrentFiscalYear } from '../utils/utils';

@Injectable({
  providedIn: 'root',
})
export class StaffedRoleService {
  private apiUrl = `${environment.apiUrl}/staffed-roles`;
  private importApiUrl = `${environment.apiUrl}/import-data`;
  API_URL = `${environment.apiUrl}/staffed-roles`;

  constructor(private http : HttpClient) {}

  getStaffedRoles(fiscalYear?: string): Observable<StaffedRole[]> {
  const params = fiscalYear ? { params: { fiscalYear } } : {};
  return this.http.get<StaffedRole[]>(`${this.API_URL}/filter`, params);
}

  getCurrentFiscalYearStaffedRoles(): Observable<StaffedRole[]> {
    return this.getStaffedRoles(getCurrentFiscalYear());
  }

  addStaffedRole(staffedRole: StaffedRole): Observable<StaffedRole> {
    return this.http.post<StaffedRole>(`${this.API_URL}`, staffedRole);
  }

  updateStaffedRole(staffedRole: StaffedRole): Observable<StaffedRole> {
    return this.http.put<StaffedRole>(`${this.API_URL}/${staffedRole.id}`, staffedRole);
  }

  deleteStaffedRole(id: number): Observable<StaffedRole> {
    return this.http.delete<StaffedRole>(`${this.API_URL}/${id}`);
  }
  importStaffedRoles(file: File): Observable<string> {
    const formData = new FormData();
    formData.append('file', file);

    // Note: The response is plain text, not JSON
    return this.http.post(
      `${this.importApiUrl}/import-staffed-roles-file`, 
      formData,
      { 
        responseType: 'text' // Important: backend returns plain text response
      }
    );
  }
  exportStaffedRoles(fiscalYear?: string): void {
    const params = fiscalYear ? `?fiscalYear=${fiscalYear}` : '';
    const url = `${this.API_URL}/export${params}`;

    this.http.get(url, { responseType: 'blob' }).subscribe({
      next: (blob) => {
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = fiscalYear ? `staffed_roles_${fiscalYear}.xlsx` : 'staffed_roles_export.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(downloadUrl);
      },
      error: (error) => console.error('Export failed:', error)
    });
  }

  previewRollover(fromYear: string, toYear: string): Observable<StaffedRoleRolloverPreview> {
    return this.http.get<StaffedRoleRolloverPreview>(`${this.API_URL}/rollover/preview`, {
      params: { fromYear, toYear }
    });
  }

  executeRollover(fromYear: string, toYear: string): Observable<StaffedRoleRolloverSummary> {
    return this.http.post<StaffedRoleRolloverSummary>(`${this.API_URL}/rollover`, null, {
      params: { fromYear, toYear }
    });
  }
}
